(function () {
  const carIconSvg = '<svg class="vehicle-brands-nav__model-icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 28l3.2-9.6A4 4 0 0113 15.5h22a4 4 0 013.8 2.9L42 28" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="4" y="28" width="40" height="9" rx="2.5" stroke="currentColor" stroke-width="2"/><circle cx="13" cy="37" r="3.5" stroke="currentColor" stroke-width="2"/><circle cx="35" cy="37" r="3.5" stroke="currentColor" stroke-width="2"/></svg>';

  class BrandSearchNav extends HTMLElement {
    constructor() {
      super();

      this.dataUrl = this.getAttribute('data-source');
      this.searchUrl = this.getAttribute('data-search-url');
      this.makes = null;

      this.triggers = Array.from(this.querySelectorAll('[data-brand-trigger]'));
      this.panel = this.querySelector('[data-brand-panel]');
      this.panelHeading = this.querySelector('[data-brand-panel-heading]');
      this.panelSubheading = this.querySelector('[data-brand-panel-subheading]');
      this.panelModels = this.querySelector('[data-brand-panel-models]');
      this.overlay = this.querySelector('[data-brand-panel-close]');

      this.activeTrigger = null;
      this.closeTimer = null;

      this.triggers.forEach((trigger) => {
        const item = trigger.closest('li') || trigger;
        trigger.addEventListener('click', this.onTriggerClick.bind(this));
        trigger.addEventListener('focus', () => this.onTriggerHover(trigger));
        item.addEventListener('mouseenter', () => this.onTriggerHover(trigger));
        item.addEventListener('mouseleave', () => this.scheduleClose());
        trigger.addEventListener('blur', () => this.scheduleClose());
      });

      this.panel.addEventListener('mouseenter', () => this.cancelClose());
      this.panel.addEventListener('mouseleave', () => this.scheduleClose());

      this.overlay.addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', (event) => {
        if (event.code === 'Escape') this.close();
      });

      this.setupHoverSlider();
    }

    setupHoverSlider() {
      this.sliderRow = this.querySelector('[data-brand-slider]');
      this.sliderList = this.querySelector('[data-brand-list]');
      if (!this.sliderRow || !this.sliderList) return;

      this.sliderTarget = 0;
      this.sliderCurrent = 0;
      this.sliderRafId = null;

      this.sliderRow.addEventListener('mousemove', (event) => {
        const maxScroll = this.sliderList.scrollWidth - this.sliderList.clientWidth;
        if (maxScroll <= 0) return;

        const rect = this.sliderRow.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        this.sliderTarget = ratio * maxScroll;
        this.runSliderLoop();
      });

      this.sliderRow.addEventListener('mouseleave', () => {
        this.sliderTarget = 0;
        this.runSliderLoop();
      });
    }

    runSliderLoop() {
      if (this.sliderRafId) return;

      const step = () => {
        this.sliderCurrent += (this.sliderTarget - this.sliderCurrent) * 0.12;
        if (Math.abs(this.sliderTarget - this.sliderCurrent) < 0.5) {
          this.sliderCurrent = this.sliderTarget;
          this.sliderList.scrollLeft = this.sliderCurrent;
          this.sliderRafId = null;
          return;
        }
        this.sliderList.scrollLeft = this.sliderCurrent;
        this.sliderRafId = requestAnimationFrame(step);
      };
      this.sliderRafId = requestAnimationFrame(step);
    }

    cancelClose() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    }

    scheduleClose() {
      this.cancelClose();
      this.closeTimer = setTimeout(() => this.close(), 150);
    }

    async onTriggerHover(trigger) {
      this.cancelClose();
      if (this.activeTrigger === trigger) return;

      const brandName = trigger.getAttribute('data-brand-name');
      const makes = await this.loadData();
      const make = makes.find((item) => item.name === brandName);
      if (!make) return;

      this.renderPanel(make);
      this.open(trigger);
    }

    async loadData() {
      if (this.makes) return this.makes;

      const response = await fetch(this.dataUrl);
      const json = await response.json();
      this.makes = json.makes;
      return this.makes;
    }

    async onTriggerClick(event) {
      const trigger = event.currentTarget;
      const brandName = trigger.getAttribute('data-brand-name');

      if (this.activeTrigger === trigger) {
        this.close();
        return;
      }

      const makes = await this.loadData();
      const make = makes.find((item) => item.name === brandName);
      if (!make) return;

      this.renderPanel(make);
      this.open(trigger);
    }

    renderPanel(make) {
      this.panelHeading.textContent = `${make.name} Modelleri`;
      this.panelSubheading.textContent = `${make.name} araç modellerini seçerek yedek parçalarına ulaşın`;

      const sortedModels = [...make.models].sort((a, b) => a.name.localeCompare(b.name, 'tr'));

      this.panelModels.innerHTML = sortedModels.map((model) => {
        const startYear = Math.min(...model.years);
        const query = encodeURIComponent(`${make.name} ${model.name}`);
        const imageUrl = model.image
          ? `${model.image}${model.image.includes('?') ? '&' : '?'}width=480`
          : '';
        const media = model.image
          ? `<img class="vehicle-brands-nav__model-image" src="${imageUrl}" alt="${make.name} ${model.name}" loading="lazy" width="240" height="88">`
          : carIconSvg;
        return `<a class="vehicle-brands-nav__model" href="${this.searchUrl}?q=${query}&type=product">
          ${media}
          <span class="vehicle-brands-nav__model-name">${model.name}</span>
          <span class="vehicle-brands-nav__model-years">${startYear}'den itibaren</span>
        </a>`;
      }).join('');

      this.panel.scrollTop = 0;
    }

    open(trigger) {
      if (this.activeTrigger) this.activeTrigger.setAttribute('aria-expanded', 'false');

      this.activeTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      this.overlay.hidden = false;
    }

    close() {
      if (!this.activeTrigger) return;

      this.activeTrigger.setAttribute('aria-expanded', 'false');
      this.activeTrigger = null;
      this.panel.hidden = true;
      this.overlay.hidden = true;
    }
  }

  customElements.define('brand-search-nav', BrandSearchNav);
})();
